import React from 'react'

import { DateConfig, useDate } from './useDate'

interface DateProp extends DateConfig {
  date: string
}

export const DateComponent = ({ date, ...dateConfig }: DateProp): JSX.Element => {
  const { formatDate } = useDate(dateConfig)
  return <>{formatDate(date)}</>
}
